import "../stylesheets/App.css";
import "../stylesheets/Awards.css";
import React from "react";
import StageItem from "./subcomponents/StageItem.js";
import Header from "./subcomponents/Header.js";

function Awards() {
  const stage = {
    idStage: 7,
    name: "Premios",
    background_url: "images/stage_banners/bg_mispuntos.png",
    active: 1,
  };

  return (
    <>
      <Header />
      <section className="stage-page ranking-page awards-page">
        <StageItem stage={stage} />
      </section>
      <section className="awards-list">
        <img
          className="awards-img"
          src={process.env.PUBLIC_URL + "/images/awards/premio.webp"}
          alt=""
        />
      </section>
    </>
  );
}

export default Awards;
